module.exports = __webpack_public_path__ + "img/dai.e54d70b7.png";